import React, { useState } from 'react';
import { UserExamService } from '@services/index';
import { useSnackbar } from '@components/utilities/SnackbarProvider';

async function updateEntity(payload, Entity) {
  const entityService = new Entity();
  const entityResponse = await entityService.update(payload);

  if (!entityResponse || !entityResponse.result) {
    return null;
  }

  return entityResponse;
}

const UserExamDelete = (props) => {
  const { setIsOpen, onUpdatedEntity, selectedEntity } = props;
  const { openSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const confirmOnClick = async () => {
    try {
      setIsLoading(true);
      const status = { id: 3, name: 'deleted', title: 'Deleted' };
      const response = await updateEntity(
        { id: selectedEntity.id, status },
        UserExamService,
      );

      if (!response || !response.success) {
        openSnackbar('Ocurrio eliminando la entidad', 'error');
        return;
      }

      setIsOpen(false);
      onUpdatedEntity(response.result);
    } catch (error) {
      console.error(error);
      openSnackbar('Ocurrio un error', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const returnOnClick = () => {
    setIsOpen(false);
  };

  return (
    <div className="col-12 mx-auto d-block">
      <div className="card">
        <div className="card-body">
          <div className="container pt-2 text-center">
            <h2 className="mb-2">
              Eliminar examen del curso "{selectedEntity.exam?.course?.name}" de
              {' ' + selectedEntity.user?.firstname}
            </h2>
            <p className="fs-5">¿Estás seguro de que quieres eliminar?</p>
            <div className="mt-4">
              {isLoading ? (
                <button class="btn btn-danger" disabled type="button">
                  <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
              ) : (
                <>
                  <button
                    className="btn btn-danger mr-2"
                    onClick={confirmOnClick}
                  >
                    <i className="fe-trash"></i> Eliminar
                  </button>
                  <button
                    className="btn btn-light btn-action ms-2"
                    onClick={returnOnClick}
                  >
                    <i className="fe-x"></i> Cancelar
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserExamDelete;
